import '@angular/localize/init';

export enum InvoiceMonth {
  January = 1,
  February = 2,
  March = 3,
  April = 4,
  May = 5,
  June = 6,
  July = 7,
  August = 8,
  September = 9,
  October = 10,
  November = 11,
  December = 12,
}

const INVOICE_MONTH_LABELS = {
  [InvoiceMonth.January]: $localize`:@@invoiceMonth.january:January`,
  [InvoiceMonth.February]: $localize`:@@invoiceMonth.february:February`,
  [InvoiceMonth.March]: $localize`:@@invoiceMonth.march:March`,
  [InvoiceMonth.April]: $localize`:@@invoiceMonth.april:April`,
  [InvoiceMonth.May]: $localize`:@@invoiceMonth.may:May`,
  [InvoiceMonth.June]: $localize`:@@invoiceMonth.june:June`,
  [InvoiceMonth.July]: $localize`:@@invoiceMonth.july:July`,
  [InvoiceMonth.August]: $localize`:@@invoiceMonth.august:August`,
  [InvoiceMonth.September]: $localize`:@@invoiceMonth.september:September`,
  [InvoiceMonth.October]: $localize`:@@invoiceMonth.october:October`,
  [InvoiceMonth.November]: $localize`:@@invoiceMonth.november:November`,
  [InvoiceMonth.December]: $localize`:@@invoiceMonth.december:December`,
};

/**
 * Returns a label for the invoice month
 * @param invoiceMonth The invoice month
 * @returns The label for the invoice month
 */
export function getLabelForInvoiceMonth(invoiceMonth: InvoiceMonth): string {
  return INVOICE_MONTH_LABELS[getInvoiceMonthNumber(invoiceMonth) as InvoiceMonth] ?? 'Unknown';
}

export function getInvoiceMonthNumber(invoiceMonth: InvoiceMonth): number {
  if (typeof invoiceMonth === 'number') {
    return invoiceMonth;
  }

  return InvoiceMonth[invoiceMonth as keyof typeof InvoiceMonth] as number;
}
